import * as Yup from "yup";

export default Yup.object().shape({
    imageUrl: Yup.string().nullable(),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string()
        .email("Wrong email format")
        .required("Email is required"),
    username: Yup.string()
        .required("Username is required"),
    phoneNumber: Yup.string().required("Phone is required"),
    dateOfBirth: Yup.string().required("Date of Birth is required"),
    payloadMultiplier: Yup.number().nullable(),
    address1: Yup.string().nullable(),
    address2: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zipCode: Yup.string().nullable(),
});